<template>
<div class="footer-links">
  <h2 class="footer-links-list-heading">{{heading}}</h2>
  <nav class="footer-nav">
    <ul class="footer-menu">
      <li v-for="link in links" :key="link.id" class="footer-menu-item">
        <router-link :to="link.target">{{link.title}}</router-link>
      </li>
    </ul>
  </nav>
</div>
</template>

<script>
export default {
  name: 'FooterLinks',
  props: {
    heading: {
      type: String,
      required: true
    },
    links: {
      type: Array,
      required: true
    }
  }
}
</script>


<style lang="scss" scoped>
@import '../../assets/sass/config';

.footer-links {
  @media (max-width: 768px) {
    width: 50%;
  }

  @media (max-width: 568px) {
    width: 100%;
  }
}

.footer-links-list-heading {
  font-size: 14px;
  font-weight: 900;
  text-transform: uppercase;
  padding: 0;
  margin: 0;
}

.footer-menu {
  font-size: 14px;
  list-style: none;
  padding: 0;
  margin: 20px 0 0;

  @media (max-width: 768px) {
    margin-bottom: 20px;
  }
}

.footer-menu-item {
  padding: 0 0 10px;
  margin: 0;

  a {
    text-decoration: none;
    transition: color 0.3s;
    font-weight: 700;

    &:hover {
      text-decoration: none;
    }
  }
}

</style>

